import React from 'react'
import styles from './UIGameEndShareReplay.module.scss'
import {ReplayControlsShareButton} from '../../UIGameReplayControls/ReplayControlsContent/ShareButton/ReplayControlsShareButton'
import {useGameStore} from '../../../store/GameStoreContext'
import {useShareReplay} from '../../../store/selectors/useShareReplay'
import {useIsReplay} from '../../../store/selectors/useIsReplay'

export const UIGameEndShareReplay = () => {
    const shareReplay = useShareReplay()
    const isReplay = useIsReplay()
    const isStatsVisible = useGameStore((state) => state.gameEnd.isVisible)

    if(isStatsVisible) return null
    if(!isReplay) return null

    return <ReplayControlsShareButton className={styles.button} onShare={shareReplay} />
}
